var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilterIcon = function SvgFilterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#AAB0BC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.273 6.977v8.426c0 .256-.204.464-.454.464-.223 0-.408-.165-.447-.381l-.007-.083-.001-8.425c.146.025.297.038.45.038.157 0 .31-.014.46-.04zm4.525 6.033c.15.026.305.04.463.04.152 0 .3-.013.445-.037v2.39c0 .256-.203.464-.453.464-.223 0-.408-.165-.447-.381l-.007-.083-.001-2.393zm6.354-6.035v8.428c0 .256-.204.464-.454.464-.223 0-.408-.165-.447-.381l-.007-.083-.001-8.423c.143.024.29.036.44.036.16 0 .316-.014.469-.041zM7.252 0c.224 0 .409.164.447.38l.008.084v8.003c.787.203 1.37.931 1.37 1.8 0 1.024-.813 1.855-1.816 1.855-1.002 0-1.815-.83-1.815-1.856 0-.86.574-1.585 1.35-1.794L6.8.464C6.8.208 7.002 0 7.253 0zM1.82 0c.223 0 .408.164.446.38l.008.084v1.972c.78.208 1.357.933 1.357 1.796 0 1.025-.813 1.856-1.815 1.856S0 5.257 0 4.232c0-.866.58-1.593 1.365-1.798V.464c0-.256.203-.464.454-.464zm10.879 0c.222 0 .408.164.446.38l.007.084.002 1.975c.774.212 1.344.935 1.344 1.793 0 1.025-.812 1.856-1.815 1.856-1.002 0-1.815-.831-1.815-1.856 0-.87.585-1.6 1.375-1.8l.002-1.968c0-.256.203-.464.454-.464z",
    transform: "translate(-1117 -168) translate(1096 156) translate(21 12)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-icon.95b65c46.svg";
export { ForwardRef as ReactComponent };